var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fudongBut"},[_c('button',{staticClass:"back-to-top flicker",class:{ 'visible': _vm.isVisible },on:{"click":_vm.makePhoneCall}},[_c('i',{staticClass:"iconfont icon-tel"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }